import { useEffect, useState } from 'react';

// Convert UTC end time to remaining time in seconds
const calculateTimeLeft = (startTime: string | number | Date) => {
  const now = new Date().getTime(); // convert to milliseconds since epoch
  const end = new Date(startTime).getTime(); // convert to milliseconds since epoch
  const timeDifference = end - now; // time difference in milliseconds
  return Math.max(Math.floor(timeDifference / 1000), 0); // convert to seconds
};

const useMasterclassCountdownTimer = (startTime: any) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(startTime));
  const [isTimerEnded, setIsTimerEnded] = useState(false);

  useEffect(() => {
    // If timeLeft reaches 0, stop the timer and call onComplete callback
    if (timeLeft <= 0) {
      setIsTimerEnded(true);
      return;
    }

    // Update timer every second
    const timerId = setInterval(() => {
      setTimeLeft(calculateTimeLeft(startTime));
    }, 1000);

    // Cleanup interval on component unmount
    // eslint-disable-next-line consistent-return
    return () => clearInterval(timerId);
  }, [timeLeft, startTime]);

  const getDay = () => {
    const days = Math.floor(timeLeft / (24 * 3600));
    return days.toString();
  };

  const gethours = () => {
    const hours = Math.floor((timeLeft % (24 * 3600)) / 3600);
    return hours.toString();
  };

  const getMinutes = () => {
    const minutes = Math.floor((timeLeft % 3600) / 60);
    return minutes.toString();
  };

  const getSeconds = () => {
    const seconds = timeLeft % 60;
    return seconds.toString();
  };

  return { getDay, gethours, getMinutes, getSeconds, isTimerEnded };
};

export default useMasterclassCountdownTimer;
